const CanvaEditReturn = () => import('@/app/canva/pages/CanvaEditReturn.vue');

export default {
  name: 'canvaEditReturn',
  path: '/canva-edit',
  component: CanvaEditReturn,
  meta: {
    analytics: 'Canva Edit Return',
    requiresAuth: true,
    hideVisionAi: true,
    hideNav: true,
    hideSecondaryNav: true,
    hidePrimaryNav: true,
  },
};
